import { Component } from 'react';
import PropTypes from 'prop-types';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { Button } from './ui/button';

class TyreManagementErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
    this.handleRetry = this.handleRetry.bind(this);
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('Tyre Management render error', error, info);
  }

  handleRetry() {
    this.setState({ error: null });
  }

  render() {
    const { error } = this.state;
    const { children } = this.props;

    if (error) {
      return (
        <div className="flex min-h-[420px] flex-col items-center justify-center rounded-2xl border border-red-200 bg-red-50/60 p-8 text-center">
          <span className="mb-4 rounded-full bg-white p-3 text-red-600 shadow-sm">
            <AlertTriangle className="h-6 w-6" />
          </span>
          <h2 className="text-lg font-bold text-slate-950">This view failed to load</h2>
          <p className="mt-2 max-w-lg text-sm text-slate-600">
            {error.message || 'Tyre Management could not load this screen.'}
          </p>
          <Button className="mt-5" onClick={this.handleRetry}>
            <RefreshCw className="h-4 w-4" />
            Try again
          </Button>
        </div>
      );
    }

    return children;
  }
}

TyreManagementErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default TyreManagementErrorBoundary;
